import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctTimestamp, FctValue18 } from '../../../../Fct/generics/FctParams';
import { votingEscrowContract } from '../helpers/supportedContracts';
export var Locked = createPlugin({
    protocol: 'CURVE',
    type: 'GETTER',
    method: 'locked',
    name: 'lockedCurveTokenAmount',
    description: 'Get information about the current CRV lock for an address.',
    supportedContracts: votingEscrowContract,
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'curve_voting_escrow', options: votingEscrowContract }),
            methodParams: {
                user: new FctAddress({}),
            },
        },
        output: {
            amount: new FctValue18({ destination: 'wei_amount', innerIndex: 0 }),
            end: new FctTimestamp({ innerIndex: 1 }),
        },
    }); },
});
